import React, { useMemo } from "react";

import { Button } from "@/components/form/Button/Button";
import { TextField } from "@/components/form/text-field/TextField";
import { useOpenModal } from "@/components/modal/utils/openModal";
import { useAuthContext } from "@/context/auth-renderer/Auth.context";
import { useLocalLadyIdContext } from "@/context/local-lady-id-context/LocalLadyId.context";
import { useFormFactory } from "@/hooks/useFormFactory";
import { FacebookRegistrationButton } from "@/shared/facebook-registration-button/FacebookRegistrationButton";
import { GoogleRegistrationButton } from "@/shared/google-registration-button/GoogleRegistrationButton";

import { useSendSignInForm } from "./hooks";
import { SignInFormSchema } from "./models";
import { useSendSignInForm as Next_useSendSignInForm } from "./rlogin/hooks";
import { SignInFormSchema as Next_SignInFormSchema } from "./rlogin/models";

type PropTypes = {
  modalVersion?: boolean;
};

export const SignInForm: React.FC<PropTypes> = ({ modalVersion }) => {
  const { openModal, removeOne } = useOpenModal();

  const localLadyId = useLocalLadyIdContext();

  const { mutate } = useSendSignInForm({ ladyIdRedirectParam: localLadyId });
  const { register: GWT_register, onSubmitHandler: GWT_onSubmitHandler } =
    useFormFactory({
      mutate,
      schema: SignInFormSchema,
    });

  const { mutate: Next_mutate } = Next_useSendSignInForm();
  const { register: Next_register, onSubmitHandler: Next_onSubmitHandler } =
    useFormFactory({
      mutate: Next_mutate,
      schema: Next_SignInFormSchema,
    });

  const { TEMPORARY_useNextAuth } = useAuthContext();

  const register = useMemo(() => {
    return TEMPORARY_useNextAuth ? Next_register : GWT_register;
  }, [GWT_register, Next_register, TEMPORARY_useNextAuth]);

  const onSubmitHandler = useMemo(() => {
    return TEMPORARY_useNextAuth ? Next_onSubmitHandler : GWT_onSubmitHandler;
  }, [GWT_onSubmitHandler, Next_onSubmitHandler, TEMPORARY_useNextAuth]);

  const openForgotPasswordModal = () =>
    openModal("FORGOT_PASSWORD_FORM_MODAL", { onClose: removeOne });

  return (
    <form className="flex flex-col gap-4" onSubmit={onSubmitHandler}>
      {modalVersion ? (
        <h2 className="text-[22px] lg:text-2xl text-grey1-800 font-[680] text-center">
          Welcome
        </h2>
      ) : (
        <h2 className="uppercase text-pink font-bold">welcome</h2>
      )}
      <TextField
        type="text"
        label="Login (ID or email)"
        {...register("username")}
      />
      <TextField type="password" label="Password" {...register("userpass")} />
      <div className="flex justify-between gap-4 items-end">
        <div className="flex gap-2">
          <GoogleRegistrationButton />
          <FacebookRegistrationButton />
        </div>
        <Button
          variant="primary"
          onHoverVariant="color-reverse"
          className="xxs:text-sm sm:text-base h-[45px] rounded-full"
          type="submit"
          fullWidth
        >
          sign in
        </Button>
      </div>
      <Button
        variant="text"
        className="text-pink underline text-[13px] lg:text-sm"
        onClick={openForgotPasswordModal}
      >
        Forgot your password?
      </Button>
    </form>
  );
};
